"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZTreeLogSelect = void 0;
const types_1 = require("@daymade/common-lib/types");
const zodSchemas_generated_1 = require("../generated/zodSchemas.generated");
const zod_1 = require("zod");
exports.ZTreeLogSelect = zodSchemas_generated_1.zodSelectTreeLog
    .pick({
    id: true,
    playerId: true,
    action: true,
    refId: true,
    refKey: true,
})
    .extend((0, types_1.ensureSubsetOfKeys)(zodSchemas_generated_1.zodSelectTreeLog.shape, {
    createdAt: zod_1.z.coerce.date(),
    orderId: zod_1.z.string().optional().nullable(),
    quantity: zod_1.z.number().optional().nullable(),
    additionalInfo: zod_1.z.optional(zod_1.z.unknown()),
}));
//# sourceMappingURL=models.js.map